import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trophy, Users, Activity, Calendar } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CompetitivePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {/* Back Button */}
      <div className="bg-white border-b border-gray-200 pt-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="inline-flex items-center text-slate-600 hover:text-slate-900 transition">
            <ArrowLeft className="w-5 h-5 mr-2" />
            <span className="font-semibold">Back to Home</span>
          </Link>
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-slate-800 text-white rounded-full text-sm font-semibold mb-4">
            Ages 12-15
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Competitive Division
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            For players ready for a higher level of commitment, intensity, and responsibility.
          </p>
        </div>

        {/* What to Know */}
        <section className="bg-white rounded-2xl border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">What to Know</h2>
          <p className="text-lg text-slate-700 leading-relaxed mb-6">
            Our Competitive Division is for players ready for a higher level of commitment, intensity, and responsibility. Training and games are structured around league play with clear performance and development goals.
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="flex items-start space-x-3">
              <div className="bg-green-600 rounded-lg p-2 mt-1">
                <Trophy className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Advanced Technical Training</h3>
                <p className="text-slate-600">Refined skills and tactical understanding</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-green-600 rounded-lg p-2 mt-1">
                <Users className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Licensed Coaches</h3>
                <p className="text-slate-600">Experienced, certified coaching staff</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-green-600 rounded-lg p-2 mt-1">
                <Calendar className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">League Matches</h3>
                <p className="text-slate-600">Regular games and tournaments</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-green-600 rounded-lg p-2 mt-1">
                <Activity className="w-5 h-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">Fitness Development</h3>
                <p className="text-slate-600">Strength training to support match demands</p>
              </div>
            </div>
          </div>
        </section>

        {/* Season Details */}
        <section className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl border border-gray-200 p-8 mb-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-4">Season Details</h2>
          <p className="text-lg text-slate-700 leading-relaxed">
            Season dates, game schedule, and exact training times will be shared directly with families upon placement on a Competitive team. Each season includes structured training sessions, competitive league matches, and potential tournament opportunities.
          </p>
        </section>

        {/* Registration CTA */}
        <section className="bg-slate-900 rounded-2xl p-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Register for Tryouts</h2>
          <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto">
            Interested in the Competitive Division? Click below to register and we'll follow up with tryout/evaluation details and team placement information.
          </p>
          <a
            href="https://register.teamsnap.com/form/awo3RZ3TmE6mqKPqY9Lsh"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-green-700 transition"
          >
            Register for Competitive
          </a>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default CompetitivePage;